import trim from 'lodash/trim';
import smEllipsis from '../../components/sm-ellipsis/sm-ellipsis';
import { isRtl } from '../../lib/document-dir-utils';



export default function ($cmp, { text, rows = 3 }) {
  const more = __('sm@_more');

  text = trim(text || '');

  return `<div class="sm-landing-appstore-app-1-section-text sm-landing-appstore-app-1-section-text--show-more" data-text=" ${more}">
    ${$cmp('sm-landing-appstore-app-1-section-text__short', smEllipsis, {
    text,
    rows,
    pre: true,
    dots: null,
    after: `<span class="sm-landing-appstore-app-1-section-text__more${isRtl() ? '-rtl' : ''}">${more}</span>`
  })}
    <div class="sm-landing-appstore-app-1-section-text__full">${text}</div>
  </div>`;
}



// WEBPACK FOOTER //
// ./src/landing-appstore-app-1/sm-landing-appstore-app-1-section-text/sm-landing-appstore-app-1-section-text.template.js